import { Box } from '@chakra-ui/react';

const BottomSpacer = () => {
  return <Box minHeight={'100'}></Box>;
};

export default BottomSpacer;
